<template>
  <v-container fluid class="pa-0">
    <!-- banner -->
    <v-row class="pl-3">
      <v-carousel cycle height="520" hide-delimiter-background show-arrows-on-hover>
        <v-carousel-item v-for="index in [1]" :key="index">
          <v-img :src="`${Utility.RES_SERVER}/static/img/cc${index}.jpeg`" sizes height="520" />
        </v-carousel-item>
      </v-carousel>
    </v-row>

    <!-- 公告滚动 -->
    <v-row class="ml-8" v-if="noticeLoaded">
      <v-col class="d-flex">
        <v-icon color="red">mdi-alarm-light-outline</v-icon>
        <template v-if="noticeList.length">
          <v-slide-y-reverse-transition>
            <div v-if="noticeIndex!=-1" class="ml-4 text-subtitle-1">
              <code class="mr-2">{{Utility.fmtDt(noticeList[noticeIndex].ct)}}</code>
              <a @click="onNoticeClick(noticeList[noticeIndex].id)">{{noticeList[noticeIndex].title}}</a>
            </div>
          </v-slide-y-reverse-transition>
        </template>
        <template v-else>
          <div class="ml-4 text-subtitle-1">暂无公告</div>
        </template>

      </v-col>
    </v-row>

    <!-- 使用步骤图 -->
    <v-row class="ml-8 mr-8" justify="space-between" align="center">
      <v-col cols="12" class="pl-0">
        <v-row dense align="center">
          <v-col cols="auto">
            <v-icon color="indigo" class="mdi-rotate-90 mdi-48px" x-large>mdi-window-minimize</v-icon>
          </v-col>
          <v-col cols="auto" class="text-h4 indigo--text">分析步骤</v-col>
        </v-row>
      </v-col>
      <v-col v-for="(item,index) in stepDataList" :key="index" :cols="item.divider ? 1 :3">
        <v-divider v-if="item.divider" />
        <v-card v-else tile height="205">
          <v-card-title>
            <v-row no-gutters justify="center">
              <v-col cols="auto">{{item.title}}</v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row align="center" no-gutters>
              <v-col cols="12">
                <v-img :src="`${Utility.RES_SERVER}${item.img}`" contain height="140" />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- 最新工具 -->
    <v-row class="ma-8" justify="center" align="center">
      <v-col cols="12" class="pl-0">
        <v-row dense align="center">
          <v-col cols="auto">
            <v-icon color="deep-orange" class="mdi-rotate-90 mdi-48px" x-large>mdi-window-minimize</v-icon>
          </v-col>
          <v-col cols="auto" class="text-h4 deep-orange--text">最新工具</v-col>
        </v-row>
      </v-col>
      <v-col v-for="(item,index) in toolDataList" :key="index" :cols="3">
        <v-hover v-slot:default="{ hover }">
          <tool-item :elevation="hover ? 12 : 2" :item="item"></tool-item>
        </v-hover>
      </v-col>
    </v-row>

    <!-- 统计数字 -->
    <v-row class="ma-8" justify="center">
      <v-col cols="12" class="pl-0">
        <v-row dense align="center">
          <v-col cols="auto">
            <v-icon color="deep-purple" class="mdi-rotate-90 mdi-48px" x-large>mdi-window-minimize</v-icon>
          </v-col>
          <v-col cols="auto" class="text-h4 deep-purple--text">平台统计</v-col>
        </v-row>
      </v-col>
      <v-col v-for="(item,index) in countDataList" :key="index" cols="3">
        <v-card tile height="215">
          <v-card-title class="grey lighten-2">
            <v-row no-gutters class="text-center" justify="center">
              <v-col cols="auto">{{item.title}}</v-col>
            </v-row>
          </v-card-title>
          <v-card-text class="text-center pt-8">
            <span class="text-h2 font-weight-bold deep-purple--text">{{item.value}}</span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="white" justify="center">
      <china-map></china-map>
    </v-row>

    <notice-detail v-if="noticeDetailVisible" v-model="noticeDetailVisible" :form-data="noticeFormData" />

  </v-container>
</template>
<script>
import { getToolList, getCloudStat, getNotice, getNoticeDetail } from '@/plugins/api';
export default {
  data () {
    return {
      // count1: 0, count2: 0, count3: 0, count4: 0, sec: 10, msec: 10,
      countDataList: [{ title: '工具总数', value: '-' }, { title: '会员数', value: '-' }, { title: '分析次数', value: '-' }, { title: '工具访问数', value: '-' }],
      toolDataList: [],

      stepDataList: [
        { title: '提交分析样本', img: '/static/img/index-step1.png' },
        { divider: true },
        { title: '设置图表参数', img: '/static/img/index-step2.png' },
        { divider: true },
        { title: '下载分析结果', img: '/static/img/index-step3.png' }
      ],

      noticeLoaded: false,
      noticeList: [],
      noticeIndex: -1,
      noticeFormData: null,
      noticeDetailVisible: false,
    }
  },
  created () {
    this.init();
  },
  methods: {
    init () {
      this.loadToolList();
      this.loadNoticeList();
      this.loadCloudStat();
    },
    loadToolList () {
      let param = { pagination: { size: 4, index: 1 } };
      getToolList(param, false).then(res => {
        this.toolDataList = res.data;
      })
    },
    loadNoticeList () {
      getNotice({}, false).then(res => {
        this.noticeList = res.data || [];
        this.noticeLoaded = true;

        if (this.noticeList.length) {
          this.noticeIndex = 0;
          setInterval(() => {
            let srcIndex = this.noticeIndex, currIndex, len = this.noticeList.length;
            if (srcIndex == -1 || srcIndex == len - 1) currIndex = 0;
            else currIndex = srcIndex + 1;
            this.noticeIndex = -1;
            this.$nextTick(() => this.noticeIndex = currIndex);
          }, 9000);
        }

      })
    },
    loadCloudStat () {
      // let numScroll = () => {
      //   this.countDataList.forEach(item => {
      //     setTimeout(() => {
      //       let value = item.value;
      //       let sep = parseInt(value / this.sec / 1000 * this.msec);
      //       let countTimer = setInterval(() => {
      //         if (item.value >= value) {
      //           item.value = value;
      //           clearInterval(countTimer);
      //           countTimer = undefined;
      //         } else item.value += sep;
      //       }, this.msec);
      //     }, 1);
      //   })
      // }
      getCloudStat().then(res => {
        let d = res.data;
        this.countDataList[0].value = d[0];
        this.countDataList[1].value = d[1];
        this.countDataList[2].value = d[2];
        this.countDataList[3].value = d[3];
        // numScroll();
      })
    },

    onNoticeClick (noticeId) {
      getNoticeDetail({ id: noticeId }, false).then(res => {
        this.noticeFormData = res.data;
        this.noticeDetailVisible = true;
      })
    }

  },
  components: {
    ChinaMap: () => import('./ChinaMap.vue'),
    ToolItem: () => import('@/views/Component/ToolItem.vue'),
    NoticeDetail: () => import('@/views/Component/NoticeDetail.vue')
  }
}
</script>